import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthChoicePanel from '../components/AuthChoicePanel';
import { getNextFromQuery } from '../../domain/authNavigation';
import { useAuthState } from '../../domain/useAuthState';

export default function LoginHubPage() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const { loading, isAuthenticated } = useAuthState();

  const nextPath = getNextFromQuery(search) ?? '/stories';

  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate(nextPath, { replace: true });
    }
  }, [isAuthenticated, loading, navigate, nextPath]);

  if (!loading && isAuthenticated) {
    return null;
  }

  return (
    <AuthChoicePanel
      nextPath={nextPath}
      eyebrow="Sign in"
      title="Choose how you want to sign in"
      description="Use the provider you prefer to unlock your reader session, then continue exactly where you left off."
    />
  );
}
